import React from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { KpiPanel } from "../../components/PanelControl";
import { sagaGetPublicados, setSelectedCatalogo } from "../../reducers/catalogoReducer/actions";
import * as pedidoActions from "../../reducers/pedidosReducer/actions";
import { publicadosSelector } from "../../selectors/catalogoSelector";
import { resumenSelector } from "../../selectors/pedidosSelector";

const filtroTemporal = {
  Ultimas24Horas: 1,
  Ultimas48Horas: 2,
  UltimaSemana: 3,
  UltimoMes: 4,
  OtroIntervalo: 5,
};

class ContainerKPI extends React.Component {
  constructor(props) {
    super(props);
    //props.sagaGetPublicados()

    this.state = {
      idFiltroTemporal: 1,
      openModal: false,
      fechaDesde: undefined,
      fechaHasta: undefined,
      fechaDesdeAsNumber: undefined,
      fechaHastaAsNumber: undefined,
      errorModal: undefined,
    };

    let payload = {
      idFiltroTemporal: this.state.idFiltroTemporal,
      fechaDesde: undefined,
      fechaHasta: undefined,
    };

    this.props.sagaGetResumenPedidosByFilterTemporal(payload);
  }

  handleOnChange = (event) => {
    let value = event.target.value;
    let name = event.target.name;

    if (name !== "filtroTemporal" || value === this.state.idFiltroTemporal) {
      return;
    }

    let openModal = this.state.openModal;

    if (value === filtroTemporal.OtroIntervalo) {
      openModal = true;
    }

    this.setState(
      {
        idFiltroTemporal: value,
        openModal: openModal,
        fechaDesde: undefined,
        fechaHasta: undefined,
        fechaDesdeAsNumber: undefined,
        fechaHastaAsNumber: undefined,
      },
      () => {
        if (!openModal) {
          let payload = {
            idFiltroTemporal: value,
            fechaDesde: undefined,
            fechaHasta: undefined,
          };
          this.props.sagaGetResumenPedidosByFilterTemporal(payload);
        }
      }
    );
  };

  handleOnClickBtnModal = (buscar) => {
    let open = this.state.openModal;

    if (buscar) {
      let error = undefined;
      if (this.state.fechaDesde === undefined || this.state.fechaHasta === undefined) {
        error = "Complete ambas fechas para realizar la búsqueda";
      }

      if (this.state.fechaDesdeAsNumber > this.state.fechaHastaAsNumber) {
        error = "La Fecha Desde no puede ser mayor a la Fecha Hasta";
      }

      this.setState({ openModal: error === undefined ? !open : open, errorModal: error }, () => {
        if (error === undefined) {
          let payload = {
            idFiltroTemporal: this.state.idFiltroTemporal,
            fechaDesde: this.state.fechaDesde,
            fechaHasta: this.state.fechaHasta,
          };
          this.props.sagaGetResumenPedidosByFilterTemporal(payload);
        }
      });
    } else {
      this.setState({
        openModal: !open,
        fechaDesde: undefined,
        fechaHasta: undefined,
        errorModal: undefined,
        fechaDesdeAsNumber: undefined,
        fechaHastaAsNumber: undefined,
      });
    }
  };

  handleOnChangeFecha = (e) => {
    let value = e.target.value;
    let name = e.target.name;
    let asNumber = e.target.valueAsNumber;

    this.setState({
      [name]: value,
      [name + "AsNumber"]: asNumber,
    });
  };

  handleOnClickKpi = (estadoPedidos) => {
    let filtros = {
      idEstadoPedido: estadoPedidos || 0,
      numeroPedido: "",
      page: 0,
      pageSize: 14,
      fechaDesde: undefined,
      fechaHasta: undefined,
      codigoArticulo: "",
      nombreArticulo: "",
      razonSocial: "",
      idCatalogo: 0,
      filtroSeleccionado: this.state.idFiltroTemporal,
    };

    if (
      this.state.idFiltroTemporal === 5 &&
      this.state.fechaDesde !== undefined &&
      this.state.fechaHasta !== undefined
    ) {
      filtros.fechaDesde = this.state.fechaDesde;
      filtros.fechaHasta = this.state.fechaHasta;
    }

    this.props.setFilterPedidos(filtros);

    window.location.hash = "/Pedidos";
  };

  handleOnPedidos = () => {};

  render() {
    return (
      <KpiPanel
        idCatalogo={this.props.catalogos.selected}
        pedidos={this.props.pedidos}
        idFiltroTemporal={this.state.idFiltroTemporal}
        openModal={this.state.openModal}
        errorModal={this.state.errorModal}
        /* acciones */
        handleOnClickKpi={this.handleOnClickKpi}
        handleOnClickBtnModal={this.handleOnClickBtnModal}
        handleOnChangeFecha={this.handleOnChangeFecha}
        handleOnChange={this.handleOnChange}
        handleOnPedidos={this.handleOnPedidos}
        pedidosURL={`/Pedidos`}
      />
    );
  }
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      sagaGetPublicados,
      setSelectedCatalogo,
      ...pedidoActions,
    },
    dispatch
  );
}

function mapStateToProps(state) {
  return {
    catalogos: publicadosSelector(state),
    pedidos: resumenSelector(state),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(ContainerKPI);
